<template>
  <div class="paging-box-el">
<!--    <div class="paging-info">-->
<!--      <div v-if="showInfo">-->
<!--        第{{ currentPage }}页 {{ pageCurTotal }}{{ desc }} ，共{{-->
<!--          Math.ceil(total / pageSize)-->
<!--        }}页--> 
<!--      </div>-->
<!--    </div>-->
    <div class="paging-wrap">
      <el-button @click="pervious">
        <div class="paging-btn">
          <img src="@/assets/page_arrow_left.png">
          <div class="paging-prev-text">上一页</div>
        </div>
      </el-button>
      <el-pagination
          background
          layout="pager"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange">
      </el-pagination>
      <el-button @click="next">
        <div class="paging-btn">
          <div class="paging-prev-text">下一页</div>
          <img src="@/assets/page_arrow_right.png">
        </div>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 100,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 12,
    },
    showInfo: {
      type: Boolean,
      default: true,
    },
    desc: {
      type: String,
      default: '个账号',
    },
    pageCurTotal: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    currentChange(val) {
      this.$emit('currentChange', val);
    },
    pervious() {
      //this.$refs.pageGroup.prev()
      if(this.currentPage <= 1){
        this.currentPage = 1;
      }else{
        this.currentChange(this.currentPage - 1)
      }
    },
    next() {
      //this.$refs.pageGroup.next()
      if(this.currentPage <= 0){
        this.currentPage = 1;
      }
      this.currentChange(this.currentPage + 1)
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.paging-box-el {
  display: flex;
  align-items: center;
  justify-content: space-between;
  //height: 32px;

  .paging-info {
    color: #999;
    font-size: 14px;
    letter-spacing: 1px;
  }
}
</style>

<style lang="scss">
.paging-box-el {
  width: 100%;
  .el-pagination {
    padding: 0;
  }
  .el-pagination.is-background {
    .el-pager li,
    .btn-prev,
    .btn-next {
      background-color: rgba(0,0,0,0);
      //border-radius: 5px;
    }
    .el-pager {
      .el-icon-more {
        background-color: rgba(0, 0, 0, 0);
      }
    }
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #FF3B30;
    //border: 1px solid #fff;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #FF3B30;
  }
  .el-pagination.is-background .el-pager .number.active:hover {
    color: #fff;
  }
  .el-pagination.is-background .el-pager li {
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    padding: 0;
    line-height: 40px;
    font-size: 18px;
    color: #696969;
  }
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    width: 40px;
    height: 40px;
    //border: 1px solid #dee2e4;
    &:hover {
      .el-icon-arrow-right::before {
        color: #FF3B30;
      }
      .el-icon-arrow-left::before {
        color: #FF3B30;
      }
    }
  }
  .paging-wrap{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .el-pagination{
      margin-left: auto;
      margin-right: auto;
    }
    .el-button{
      border: none;
      padding: 0;
      .paging-btn{
        height: 40px;
        width: 100px;
        display: flex;
        align-items: center;
        img{
          width: 20px;
          height: 20px;
          display: block;
        }
        .paging-prev-text{
          margin-left: 20px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: 400;
          color: #696969;
        }
        .paging-prev-text{
          margin-right: 20px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: 400;
          color: #696969;
        }
      }
    }
  }
}
</style>
